module.exports = __webpack_public_path__ + "img/3.3609fce7.png";